(() => {
  function init() {
    document.querySelectorAll('[data-mt-reader]').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      const root = dialog.closest('section');
      const image = dialog.querySelector('[data-reader-image]');
      const viewport = dialog.querySelector('[data-reader-viewport]');
      const position = dialog.querySelector('[data-reader-position]');
      const title = dialog.querySelector('[data-reader-title]');
      const download = dialog.querySelector('[data-reader-download]');
      const prev = dialog.querySelector('[data-reader-prev]');
      const next = dialog.querySelector('[data-reader-next]');
      let items = [], index = 0, trigger, zoom = 1, original = false, drag;
      const fitWidth = () => Math.max(1, viewport.clientWidth - parseFloat(getComputedStyle(viewport).paddingLeft) * 2);
      function size(reset = false) {
        image.style.width = `${Math.round(original ? image.naturalWidth : fitWidth() * zoom)}px`;
        position.textContent = `${index + 1} / ${items.length} · ${original ? 'Original size' : Math.round(zoom * 100) + '%'}`;
        if (reset) viewport.scrollTo({top:0,left:0,behavior:'instant'});
      }
      function show(n) {
        index = Math.max(0, Math.min(items.length - 1, n));
        const item = items[index], group = item.closest('[data-reader-group]');
        zoom = 1; original = false;
        image.width = Number(item.querySelector('img')?.getAttribute('width')) || 1;
        image.height = Number(item.querySelector('img')?.getAttribute('height')) || 1;
        image.alt = item.querySelector('img')?.alt || '';
        title.textContent = item.dataset.readerTitle || image.alt;
        image.src = item.dataset.readerSrc;
        download.hidden = !group?.dataset.readerDownload;
        if (!download.hidden) download.href = group.dataset.readerDownload;
        else download.removeAttribute('href');
        prev.disabled = index === 0; next.disabled = index === items.length - 1;
        size(true);
      }
      image.addEventListener('load', () => size(true));
      root.querySelectorAll('[data-reader-src]').forEach(button => button.addEventListener('click', () => {
        trigger = button;
        items = [...button.closest('[data-reader-group]').querySelectorAll('[data-reader-src]')];
        dialog.showModal();show(items.indexOf(button));dialog.querySelector('[data-reader-close]').focus();
      }));
      prev.addEventListener('click', () => show(index - 1));next.addEventListener('click', () => show(index + 1));
      const fit = () => {original = false;zoom = 1;size(true);};
      dialog.querySelector('[data-reader-fit]').addEventListener('click', fit);
      dialog.querySelector('[data-reader-reset]').addEventListener('click', fit);
      dialog.querySelector('[data-reader-original]').addEventListener('click', () => {original = true;size(true);});
      const changeZoom = step => {zoom = Math.max(.5,Math.min(8,(original ? image.naturalWidth / fitWidth() : zoom) * step));original = false;size();};
      dialog.querySelector('[data-reader-in]').addEventListener('click', () => changeZoom(1.5));
      dialog.querySelector('[data-reader-out]').addEventListener('click', () => changeZoom(1 / 1.5));
      dialog.querySelector('[data-reader-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {image.removeAttribute('src');trigger?.focus({preventScroll:true});});
      viewport.addEventListener('keydown', e => {
        const steps = {ArrowLeft:[-100,0],ArrowRight:[100,0],ArrowUp:[0,-100],ArrowDown:[0,100]};
        if (steps[e.key]) {e.preventDefault();viewport.scrollBy({left:steps[e.key][0],top:steps[e.key][1],behavior:'instant'});}
      });
      viewport.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = {x:e.clientX,y:e.clientY,left:viewport.scrollLeft,top:viewport.scrollTop};
        viewport.setPointerCapture(e.pointerId);viewport.classList.add('is-dragging');
      });
      viewport.addEventListener('pointermove', e => {if(drag){viewport.scrollLeft=drag.left+drag.x-e.clientX;viewport.scrollTop=drag.top+drag.y-e.clientY;}});
      const endDrag = () => {drag=null;viewport.classList.remove('is-dragging');};
      viewport.addEventListener('pointerup',endDrag);viewport.addEventListener('pointercancel',endDrag);
      new ResizeObserver(() => {if(dialog.open)size();}).observe(viewport);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
